module.exports = window["__sharedReduxSagaEffects"];